import React, { useEffect, useState } from 'react';
import { ChartData, ChartRow, LineThrough, SizeContainer } from './styled';
import { sizeMapping } from '../constants';
import { SnackBar } from '../../Product/PdpHeader/styled';
import { fetchAvailableSizes } from '../../../datafetchers/maternityPage';
import SizeSkeleton from '../Skeleton';
import { clickedCtaEvent } from '../instrumentation';

const SelectSizeTable = (props) => {
  const { sizeData, activeSize, setActiveSize, setDisabled, productName } =
    props;
  const [availableSizes, setAvailableSizes] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const sizeSelectHandler = (item) => {
    if (item.status === '2') {
      setActiveSize(item.id);
      setDisabled(false);
    } else {
      setShowToast(true);
    }
    const url = window.location.pathname;
    clickedCtaEvent(
      productName,
      item.id,
      url.substring(0, 99),
      sizeMapping[item.size],
    );
  };
  useEffect(() => {
    if (showToast)
      setTimeout(() => {
        setShowToast(false);
      }, 2000);
  }, [showToast]);

  const fetchStatusOfProducts = async () => {
    const statuses = await fetchAvailableSizes(sizeData);
    setAvailableSizes(statuses?.data);
  };

  useEffect(() => {
    if (sizeData?.length && availableSizes === null) {
      fetchStatusOfProducts();
    }
  }, [sizeData]);

  return (
    <SizeContainer>
      <SnackBar className={showToast ? 'show' : ''}>
        This size is not currently available.
      </SnackBar>
      {availableSizes === null ? (
        <SizeSkeleton />
      ) : (
        <>
          <ChartRow>
            {availableSizes?.map((item) => {
              return (
                <ChartData
                  key={item.id}
                  className={activeSize === item.id ? 'active' : ''}
                  onClick={() => sizeSelectHandler(item)}
                >
                  <LineThrough
                    className={item.status != '2' ? 'disabled' : ''}
                  ></LineThrough>
                  <p className={item.status != '2' ? 'disabled' : ''}>
                    {sizeMapping[item.size] || item.size}
                  </p>
                </ChartData>
              );
            })}
          </ChartRow>
        </>
      )}
    </SizeContainer>
  );
};

export default SelectSizeTable;
